export enum Filters {
  STATUS = 'status',
  RECIPIENT = 'recipient',
  SENDER = 'sender',
}
